import gql from 'graphql-tag';

export const GET_TERMS = gql`
  query {
    getTermsPrivacy {
      id
      text
    }
  }
`;

export const UPDATE_TERMS = gql`
  mutation($text: String){
    updateTermsPrivacy(text: $text){
        id
        text
    }
  }
`